<template>
<section>
    <div class="dashboard_wrapper">

        <!-- <div v-if="!cityAdmin" class="ml-20">
            <div class="row">
                <div class="city_rel_class">
                    <multiselect v-model="city" deselect-label="" track-by="value" label="name" placeholder="Select city" :options="cityList" :searchable="true" :allow-empty="false" @select="onCitySelect">
                    </multiselect>
                </div>
            </div>

        </div> -->
        <!-- <div v-if="noCity">
            <div>No cities available</div>
            <router-link :to="{ name: 'addCity', params: { _id: '0' } }">
                <a>Click here to add city</a>
            </router-link>
        </div> -->
        <div :class="addButtonClass" class="ml-20" v-if="noCity">
            <h4>No cities available </h4>
            <router-link :to="{ name: 'addCity', params: { _id: '0' } }">
                <button class=" btn gradientbt">Add City</button>
            </router-link>
        </div>

        <div class="panel-body">
            <div class="row dashBoardboxs_wrp" >
                <div class="col-sm-3">
                    
                    <router-link :class="{ 'disabled-link': adminCheck == 'reportManager' || adminCheck == 'monitoringManager' }" :to="{ name: 'Primarytrip' , params: { tripStatus: 'complete' ,cityIds:this.cityIds } } ">
                        <div class="dashBoardboxs">
                            <span class="img_side">
                                <img src="/static/img/completed_trips_img.png" />
                            </span>
                            <span class="content_side">
                                <h1 class="number">{{ allTripDetails.complete ? allTripDetails.complete : '0' }}</h1>
                                <p class="text">Completed Trips</p>
                            </span>
                        </div>
                    </router-link>
                    </div>
             
               
                <div class="col-sm-3">
                    <router-link :class="{ 'disabled-link': adminCheck == 'reportManager' || adminCheck == 'monitoringManager' }" @click.prevent="handleLinkClick" :to="{ name: 'Primarytrip' , params: { tripStatus: 'ongoing' ,cityIds:this.cityIds } }">
                    <div class="dashBoardboxs">

                        <span class="img_side">
                            <img src="/static/img/ongoing_trip_img.png" />
                        </span>
                        <span class="content_side">
                            <h1 class="number">{{ allTripDetails.ongoing ? allTripDetails.ongoing : '0' }}</h1>
                            <p class="text">Ongoing Trips</p>
                        </span>
                    </div>
                </router-link>
                </div>
               
               
                <div class="col-sm-3">
                    <router-link :class="{ 'disabled-link': adminCheck == 'reportManager' || adminCheck == 'monitoringManager' }" :to="{ name: 'Primarytrip' , params: { tripStatus: 'scheduled',cityIds:this.cityIds } }">
                    <div class="dashBoardboxs">

                        <span class="img_side">
                            <img src="/static/img/schedule_trip_img.png" />
                        </span>
                        <span class="content_side">
                            <h1 class="number">{{ allTripDetails.scheduled ? allTripDetails.scheduled : '0' }}</h1>
                            <p class="text">Scheduled Trips</p>
                        </span>
                    </div>
                </router-link>
                </div>
              
               
                <div class="col-sm-3">
                    <router-link :class="{ 'disabled-link': adminCheck == 'reportManager' || adminCheck == 'monitoringManager' }" :to="{ name: 'surveys' , params: { surveyStatus: 'scheduled' ,cityIds:this.cityIds} }">
                    <div class="dashBoardboxs">

                        <span class="img_side">
                            <img src="/static/img/schedule_surveys_img.png" />
                        </span>
                        <span class="content_side">
                            <h1 class="number">
                                {{ allDashboardDetails.PendingAndUpcomingSurveyCount ? allDashboardDetails.PendingAndUpcomingSurveyCount : '0' }}
                            </h1>
                            <p class="text">Scheduled Surveys</p>
                        </span>
                    </div>
                </router-link>
                </div>
               
              
                <div class="col-sm-3">
                    <router-link :class="{ 'disabled-link': adminCheck == 'reportManager' || adminCheck == 'monitoringManager' }" :to="{ name: 'surveys' , params: { surveyStatus: 'complete' ,cityIds:this.cityIds} }">
                    <div class="dashBoardboxs">
                        <span class="img_side">
                            <img src="/static/img/completed_surverys_img.png" />
                        </span>
                        <span class="content_side">
                            <h1 class="number">
                                {{ allDashboardDetails.CompletedSurveyCount ? allDashboardDetails.CompletedSurveyCount : '0' }}
                            </h1>
                            <p class="text">Completed Surveys</p>
                        </span>
                    </div>
                </router-link>
                </div>
               
               
                <div class="col-sm-3">
                    <router-link :class="{ 'disabled-link': adminCheck == 'reportManager' || adminCheck == 'monitoringManager' || adminCheck == 'superVisor' }" :to="{ name: 'wasteCollectionArea', params: { cityIds:this.cityIds , status: 'Active'}}">
                    <div class="dashBoardboxs">

                        <span class="img_side">
                            <img src="/static/img/waste_collection_area_img.png" />
                        </span>
                        <span class="content_side">
                            <h1 class="number">
                                {{ allDashboardDetails.WasteCollectionAreaCount ? allDashboardDetails.WasteCollectionAreaCount : '0' }}
                            </h1>
                            <p class="text">Zones</p>
                        </span>
                    </div>
                </router-link>
                </div>
               
               
                <div class="col-sm-3">
                    <router-link :class="{ 'disabled-link': adminCheck == 'reportManager' || adminCheck == 'monitoringManager' || adminCheck == 'superVisor' }" :to="{ name: 'vehicles' ,params: { cityIds:this.cityIds , status: 'Active'}}">
                    <div class="dashBoardboxs">
                        <span class="img_side">
                            <img src="/static/img/vehicles_img.png" />
                        </span>
                        <span class="content_side">
                            <h1 class="number">{{ allDashboardDetails.VehicleCount ? allDashboardDetails.VehicleCount : '0' }}</h1>
                            <p class="text">Vehices</p>
                        </span>

                    </div>
                </router-link>
                </div>
               
                
                <div class="col-sm-3">
                    <router-link :class="{ 'disabled-link': adminCheck == 'reportManager' || adminCheck == 'monitoringManager' || adminCheck == 'superVisor' }" :to="{ name: 'helperAndDriver' , params: { roleType: 'driver' ,cityIds:this.cityIds } }">
                    <div class="dashBoardboxs">
                        <span class="img_side">
                            <img src="/static/img/driver_img.png" />
                        </span>
                        <span class="content_side">
                            <h1 class="number">{{ allDashboardDetails.DriverCount ? allDashboardDetails.DriverCount : '0' }}</h1>
                            <p class="text">Drivers</p>
                        </span>
                    </div>
                </router-link>
                </div>
                
            </div>

        </div>
  
          <div class="welcome_img">
            <div class="welcome_img_flex">
                <span>
                  <img src="/static/img/welcome_back_img.png"/>
            </span>
            <span class="welcome_heading">
                <h3>Welcome to {{this.$store.state.auth.user.role.key == "superAdmin" ? "Admin" : this.$store.state.auth.user.cityId.cityName}}</h3>
                <p>With Our Platform, You Can Create And Manage Houses, Surveys And Trips.</p>
            </span>
            </div>
        </div>
   
        <!-- <div class="row">
        <div class="col-sm-6">
          <div class="graph_img">
            <img src="/static/img/total_wastecollection_img.png" />
          </div>
        </div>

        <div class="col-sm-6">
          <div class="graph_img">
            <img src="/static/img/survey_status.png" />
          </div>
        </div>

        <div class="col-sm-6">
          <div class="graph_img">
            <img src="/static/img/total_income.png" />
          </div>
        </div>

        <div class="col-sm-6">
          <div class="graph_img">
            <img src="/static/img/total_expenses.png" />
          </div>
        </div>

        <div class="col-sm-6">
          <div class="graph_img">
            <img src="/static/img/wastea_collection_categories.png" />
          </div>
        </div>
      </div> -->
    </div>
    <div v-if="noCity">
        <div>No cities available</div>
        <router-link :to="{ name: 'surveysCreate', params: { _id: '0' } }">
            <a>Click here to add city</a>
        </router-link>
    </div>
</section>
</template>

<script>
import {
    eventBus,
    dashboardService
} from "../../../services";

export default {
    name: "DashBoard",
    data() {
        return {
            allTripDetails: {},
            allDashboardDetails: {},
            cityId: "",
            cityIds:{},
            
            city: "",
            cityList: [],
            loading: null,
            cityAdmin: false,
            noCity: false,
            adminCheck: "",
            user: [{
                    title: "102",
                    subTitle: "Vehicle on Duty",
                },
                {
                    title: "102 KG",
                    subTitle: "Total Waste Collection (in Kgs.)",
                },
                {
                    title: "102",
                    subTitle: "Today’s Workers On Duty ",
                },
                {
                    title: "102",
                    subTitle: "Pending Survey’s",
                },
                {
                    title: "102",
                    subTitle: "Completed Survey’s",
                },
                {
                    title: "102",
                    subTitle: "Total Expenses",
                },
                {
                    title: "102",
                    subTitle: "Total Income",
                },
            ],
        };
    },

    methods: {
        getTripsCount(id) {
            return dashboardService
                .gettAllTripCount(id)
                .then((response) => {
                    this.allTripDetails = response.data;
                })
                .catch((error) => {
                    this.$snotify.error(response.data.error, "Error!");
                });
        },

        getallDetails(id) {
            return dashboardService
                .allDashboardDetails(id)
                .then((response) => {

                    this.allDashboardDetails = response.data.response;
                })
                .catch((error) => {
                    this.$snotify.error(response.data.error, "Error!");
                });
        },

        getCityList() {
            const params = {};
            this.cityList = [];
            let cities = [];
            this.$cityRepository
                .collectionCitysList(params)
                .then((res) => {
                    this.loading = false;
                    if (res.data.response.length > 0) {
                        res.data.response.forEach((element) => {

                            if (element.status === true) {
                                cities.push({
                                    name: element.cityName.length > 25 ?
                                        element.cityName.slice(0, 25) + "..." : element.cityName,
                                    value: element._id,
                                });
                            }
                        });
                        this.cityList = cities;
                        // this.$store.state.auth.cityId = this.cityList[0]
                        // this.city = this.cityList[0]
                        this.cityIds = this.$store.state.auth.cityId
                       if(this.$store.state.auth.cityId && this.$store.state.auth.cityId.value){
                            this.getTripsCount(this.$store.state.auth.cityId.value);
                            this.getallDetails(this.$store.state.auth.cityId.value);
                       }
                        
                    } else {
                        this.noCity = true
                    }

                })
                .catch((error) => {
                    this.loading = false;
                    console.error("cities.requestFunction-error:", error);
                    this.$snotify.error("Get cities list failed", "Error!");

                });
        },
        onCitySelect(city) {
            this.cityIds = city
            this.getTripsCount(city.value);
            this.getallDetails(city.value);
        }
    },
//     watch: {
//     '$store.state.auth.cityId.value': {
//       immediate: true,
//       handler(newCityId) {
//         this.getTripsCount(newCityId);
//         this.getallDetails(newCityId);
//       },
//     },
//   },
    mounted(){
        eventBus.$on('cityIdChanged', this.onCitySelect);
        // this.getTripsCount(this.$store.state.auth.cityId.value);
        // this.getallDetails(this.$store.state.auth.cityId.value);
       
    },
    created() {
        // eventBus.$on('cityIdChanged', (newCityId) => {
        //     if(newCityId){
        //         this.onCitySelect(newCityId)
        //     }
        // });
        this.adminCheck = this.$store.state.auth.user.role.key;
        if (!this.$store.state.auth.user.cityId) {
            this.getCityList()
        } else {
            this.cityAdmin = true;
            let cityId = this.$store.state.auth.user.cityId._id;
            this.getTripsCount(cityId);
            this.getallDetails(cityId);
        }
    },
};
</script>

<style scoped>
.city_select_boxs {
    text-align: right;
    margin-bottom: 20px;
}

.city_select_boxs select {
    background: #FFFFFF;
    border: 1px solid #D9D9D9;
    border-radius: 4px;
    width: 200px;
    color: #000000;
    font-size: 16px;
    font-weight: 600;
    padding: 5px;
}

.on_duty_drivers table {
    margin: 0px;
}

.on_duty_drivers table tr th {
    background: #DDDDDD;
    border: 0px;
    padding: 10px;
}

.on_duty_drivers table tr th:nth-child(1) {
    border-radius: 5px 0px 0px 5px;
}

.on_duty_drivers table tr th:nth-child(2) {
    border-radius: 0px 5px 5px 0px;
}

.on_duty_drivers table tr td {
    border: 0px;
    padding: 10px;
    border-bottom: 2px solid #ddd;
}

.on_duty_drivers {
    background: #FFFFFF;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12);
    border-radius: 12px;
    padding: 15px;
}

.on_duty_drivers table {
    width: 100%;
}

.on_duty_drivers h4 {
    margin-bottom: 15px;
}

.on_duty_drivers table tr:nth-last-child(1) td {
    border-bottom: 0px;
}
.welcome_img{
    text-align: center;
}
.dashBoardboxs {
    background: #FFFFFF;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.12);
    border-radius: 6px;
    padding: 12px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}
.disabled-link {
  pointer-events: none;

}
span.img_side {
    background: #EBFFF6;
    padding: 5px;
    width: 55px;
    border-radius: 50%;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;

}

h1 {
    margin: 0;
    padding: 0;
}

p {
    margin: 0;
    padding: 0;
}

.dashBoardboxs h1 {
    font-size: 28px;
    font-weight: 600;
    color: #0F6940;
}

.dashBoardboxs p {
    font-size: 16px;
    font-weight: 600;
    padding-top: 6px;
    color: #696969;
    font-weight: 500;
}

.graph_img {
    margin-bottom: 20px;
}

.graph_img img {
    width: 100%;
}

.dashboard_wrapper {
    overflow: hidden;
    height: calc(100vh - 130px);
    overflow-y: auto;
}

.dashboard_wrapper::-webkit-scrollbar {
    width: 5px;
}

.dashboard_wrapper::-webkit-scrollbar-thumb {
    background: #888;
}

.city_dropdown {
    margin-top: 40px;

}

.city_rel_class {
    padding-left: 15px;
    padding-right: 15px;
    width: 18%;
}

.city_rel_class {
    position: relative;
    right: 16px;
    float: right;
}
.welcome_img{
    text-align: center;
    height: calc(100vh - 426px);
}
.welcome_img_flex {
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: center;
}
.welcome_img_flex img {
    max-width: 445px;
}
.welcome_heading{
    text-align: left;
}
.welcome_heading h3{
    font-size: 40px;
    font-weight: 700;
    color: #0F6940;
}
.welcome_heading p{
    font-size: 16px;
}
.welcome_img_flex{
    padding-left:15px;
}



@media(max-width:1599px){
    .welcome_img_flex img{
        max-width: 380px;
    }
}
@media(max-width:1199px){
    .welcome_img_flex{
    flex-direction: column;
}
.welcome_heading{
    text-align: center;
}
.welcome_img{
    height: inherit;
}


}
@media(max-width:767px){
    .city_rel_class{
        position: relative;
        right: 16px;
        float: right;
        width: 180px;
        top: 8px;
    }
    .welcome_img_flex img{
    max-width: 285px;
}
.welcome_heading h3 {
    font-size: 28px;
}
.welcome_img_flex{
    padding: 15px;
}


}

</style>



// WEBPACK FOOTER //
// dashboard.vue?92f7d500